import { render, staticRenderFns } from "./TabsCards.vue?vue&type=template&id=9f17ed96"
import script from "./TabsCards.vue?vue&type=script&lang=js"
export * from "./TabsCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports